import { Topbar } from '../../components/Topbar/Topbar';
import { Alert, Button, Container, ListGroup, Modal } from 'react-bootstrap';
import { Footer } from '../../components/Footer/Footer';
import { useEffect, useState } from 'react';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faCircle,
  faEnvelope,
  faEnvelopeOpen,
  faEnvelopeOpenText,
  faLock,
  faLockOpen,
  faMinusSquare,
  faPlusSquare,
  faSquare,
  faUser,
  faUserSlash,
} from '@fortawesome/free-solid-svg-icons';
import { formatSecondsTimestamp } from '../../utils/utils';
import { TicketStatusBadge } from '../../components/TicketStatusBadge/TicketStatusBadge';
import { WithTooltip } from '../../components/WithTooltip/WithTooltip';
import { TicketForm } from '../../components/TicketForm/TicketForm';
import { UserUID } from '../../components/UserUID/UserUID';
import { useCapacitor } from '../../../hooks/useCapacitor';
import './Tickets.scss';
import { Copyable } from '../../components/Copyable/Copyable';
import { useTranslation } from 'react-i18next';
import { Title } from '../../components/Title/Title';
import Switch from 'react-switch';

const TicketsComponent = () => {
  const { getTickets, currentUser } = useFirebase();
  const [tickets, setTickets] = useState<any[]>(null);
  const [filteredList, setFilteredList] = useState<any[]>([]);
  const history = useHistory();
  const [isAdmin, setIsAdmin] = useState(false);
  const [isNewTicketModalOpen, setIsNewTicketModalOpen] = useState(false);
  const { isNative } = useCapacitor();
  const { t } = useTranslation();

  const [showOpenTickets, setShowOpenTickets] = useState(true);

  useEffect(() => {
    const asAdmin = window.location.pathname.startsWith('/admin/tickets');
    setIsAdmin(asAdmin);
    getTickets(asAdmin).then(setTickets);
  }, [isAdmin]);

  useEffect(() => {
    setFilteredList(tickets?.slice() || []);
  }, [tickets]);

  useEffect(() => {
    if (!tickets) return;
    setFilteredList(tickets.filter((ticket) => !!ticket.status.closed == !showOpenTickets));
  }, [tickets, showOpenTickets]);

  if (!filteredList) return <FullscreenLoader />;

  return (
    <>
      <Title>{t('labels.tickets')}</Title>

      <div style={{ marginBottom: '72px' }}>
        <div style={{ backgroundColor: '#141414', position: 'fixed', top: '0', left: '0', right: '0', zIndex: 100 }}>
          <Topbar />
        </div>
      </div>

      <Container className={'my-5'}>
        <div className={'d-flex align-items-center'}>
          {!isAdmin && (
            <Button variant={'outline-light'} onClick={() => history.goBack()} className={'mr-2'}>
              <FontAwesomeIcon icon={faArrowLeft} />
            </Button>
          )}
          <div className={'display-4'}>{isAdmin ? 'Tutti i ticket' : t('tickets.labels.tuoiTicket')}</div>
        </div>

        <div className={'d-flex align-items-start align-items-sm-center flex-column flex-sm-row mt-4 mb-3 ml-2'}>
          <div className={'d-flex align-items-start align-items-lg-center flex-grow-1 flex-column flex-lg-row'}>
            <div className={'mr-3'}>
              <span className={'text-primary'}>
                <FontAwesomeIcon icon={faEnvelopeOpenText} className={'mr-2'} />
              </span>
              <span className={'font-weight-bold'}>{t('tickets.labels.aggiornamentiDaLeggere')}</span>
            </div>
            <div className={'mr-3'}>
              <span className={'text-secondary'}>
                <FontAwesomeIcon icon={faEnvelopeOpen} className={'mr-2'} />
              </span>
              <span>{t('tickets.labels.nessunAggiornamento')}</span>
            </div>
            <div>
              <span className={'text-secondary'}>
                <FontAwesomeIcon icon={faEnvelope} className={'mr-2'} />
              </span>
              <span className={'text-muted'}>{t('tickets.labels.ticketChiuso')}</span>
            </div>
          </div>
          {!isAdmin && (
            <Button className={'ml-auto'} variant={'primary'} style={{ whiteSpace: 'nowrap' }} onClick={() => setIsNewTicketModalOpen(true)}>
              {t('tickets.labels.nuovoTicket')}
            </Button>
          )}
        </div>

        <div className={'d-flex align-items-center mb-3'}>
          <span className={'mr-2'}>
            <strong>{t('ticket.labels.mostraTicket')}</strong>
          </span>
          <span className={'mr-2'}>{t('labels.chiusi')}</span>
          <Switch
            checked={showOpenTickets}
            onChange={setShowOpenTickets}
            onColor={'#3393d0'}
            checkedIcon={false}
            uncheckedIcon={false}
            height={16}
            width={32}
            handleDiameter={14}
          />
          <span className={'ml-2'}>{t('labels.aperti')}</span>
        </div>

        {!filteredList.length && <p className={'text-center mt-4'}>{t('tickets.labels.nessunTicket')}</p>}

        {!!filteredList.length && (
          <>
            {isAdmin && (
              <Alert variant={'warning'} className={'mb-3'}>
                <span className={'font-weight-bold mr-1'}>{t('labels.attenzione')}!</span>
                <span>Eventuali aggiornamenti da leggere si riferiscono all'utente, non all'amministrazione.</span>
              </Alert>
            )}
            <ListGroup>
              {filteredList.map((ticket) => (
                <ListGroup.Item
                  key={ticket.id}
                  variant={'dark'}
                  className={'dark-list-item'}
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    const url = (() => {
                      if (isAdmin) return `/admin/ticket/${ticket.id}`;
                      else return `/ticket/${ticket.id}`;
                    })();
                    history.push(url);
                  }}
                >
                  {isAdmin && (
                    <div className={'mb-1 d-flex justify-content-between flex-column flex-sm-row'} onClick={(event) => event.stopPropagation()}>
                      <div className={'d-flex flex-column flex-sm-row'}>
                        <div className={'d-flex'}>
                          {ticket.newMessageFromUser && (
                            <div className={'align-self-start circle-pulse text-success mr-2'}>
                              <FontAwesomeIcon icon={faCircle} size={'sm'} style={{ position: 'absolute', top: '1px', left: '1px' }} />
                            </div>
                          )}
                          <small className={'mr-1'}>Aperto da</small>
                          <small className={'font-weight-bold mr-1'}>{ticket.name}</small>
                        </div>
                        <small>
                          (<UserUID uid={ticket.uid} />)
                        </small>
                      </div>
                      <div className={'d-flex align-items-center'}>
                        <small className={'mr-1'}>Ticket ID:</small>
                        <small className={'mr-2'}>
                          <Copyable text={ticket.id} />
                        </small>
                        <span className={'ml-auto ' + (ticket.rating == 1 ? 'text-success' : ticket.rating == -1 ? 'text-danger' : 'text-secondary')}>
                          <WithTooltip
                            text={ticket.rating ? (ticket.rating == 1 ? 'Valutazione positiva' : 'Valutazione negativa') : 'Nessuna valutazione'}
                            big={false}
                          >
                            <FontAwesomeIcon
                              icon={ticket.rating ? (ticket.rating == 1 ? faPlusSquare : faMinusSquare) : faSquare}
                              size={'sm'}
                              fixedWidth={true}
                            />
                          </WithTooltip>
                        </span>
                        <span
                          className={'ml-2 ' + (ticket.assignee ? (ticket.assigneeUid == currentUser.uid ? 'text-primary' : 'text-secondary') : 'text-warning')}
                        >
                          <WithTooltip text={ticket.assignee || 'Non assegnato'} big={false}>
                            <FontAwesomeIcon icon={ticket.assignee ? faUser : faUserSlash} size={'sm'} fixedWidth={true} />
                          </WithTooltip>
                        </span>
                      </div>
                    </div>
                  )}
                  <div className={'d-flex flex-column flex-md-row align-items-start align-items-md-center'}>
                    <div className={'d-flex align-items-center'}>
                      <div className={(ticket.hasNew ? 'text-primary' : 'text-secondary') + ' mr-2'}>
                        <FontAwesomeIcon
                          fixedWidth={true}
                          icon={(() => {
                            if (ticket.hasNew) return faEnvelopeOpenText;
                            if (ticket.status.closed) return faEnvelope;
                            return faEnvelopeOpen;
                          })()}
                        />
                      </div>
                      <div
                        className={
                          'mr-2 ' +
                          (() => {
                            if (ticket.hasNew) return 'font-weight-bold';
                            if (ticket.status.closed) return 'text-muted';
                            return '';
                          })()
                        }
                      >
                        {ticket.subject}
                      </div>
                    </div>
                    <div className={'d-flex flex-column flex-xl-row align-items-end align-items-xl-center ml-auto'}>
                      <div className={'d-flex align-items-center'}>
                        <TicketStatusBadge status={ticket.status} />
                        <div className={'ml-3 d-flex align-items-center ' + (ticket.status.closed ? 'text-secondary' : 'text-primary')}>
                          <WithTooltip text={ticket.status.closed ? t('labels.chiuso') : t('labels.aperto')} big={false}>
                            <FontAwesomeIcon icon={ticket.status.closed ? faLock : faLockOpen} fixedWidth={true} size={'xs'} />
                          </WithTooltip>
                        </div>
                      </div>
                      <small className={'ml-3'} style={{ whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>
                        <span className={'text-muted'}>{t('labels.risposte')}</span> {ticket.replies}
                      </small>
                      <small className={'ml-3'} style={{ whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>
                        <span className={'text-muted'}>{t('labels.apertoIl')}</span> {formatSecondsTimestamp(ticket.created._seconds, 'dd/MM/Y HH:mm')}
                      </small>
                      <small className={'ml-3'} style={{ whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>
                        <span className={'text-muted'}>{t('labels.ultimoAggiornamento')}</span>{' '}
                        {formatSecondsTimestamp(ticket.updated._seconds, 'dd/MM/Y HH:mm')}
                      </small>
                    </div>
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </>
        )}
      </Container>

      <Footer />

      <Modal centered={isNative} show={isNewTicketModalOpen} onHide={() => setIsNewTicketModalOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{t('tickets.labels.nuovoTicket')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TicketForm className={'mt-0'} onSuccess={(ticketId) => history.push(`/ticket/${ticketId}`)} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default TicketsComponent;
